export { default } from '@components/SocialLinks/SocialLinks'
